var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error-handler'),_c('generic-modal'),_c('daily-limit-dialog'),_c('router-view'),_c('ask-bizminer-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }